import { gql } from '@apollo/client';

export const UPDATE_PARTICIPANTS_NUMBER = gql`
  mutation UpdateParticipantNumber(
    $projectId: ID!,
    $participantsNumber: Int!,
    $token: String,
    $couponCode: String,
    $rememberCard: Boolean!,
    $paymentMethodId: String,
    $segmentId: ID!,
  ) {
    updateParticipantsNumber(
      projectId: $projectId,
      participantsNumber: $participantsNumber,
      token: $token,
      couponCode: $couponCode,
      rememberCard: $rememberCard,
      paymentMethodId: $paymentMethodId,
      segmentId: $segmentId,
    ) {
      project {
        id
        audienceParticipants
        status
      }
    }
  }
`;
